import {MathUtils,Quaternion,Vector3} from 'three';
import {GLIDE,stepFlightVelocity,type FlightVelocity,type FlightStep} from '../../../shared/src/flightPhysics';
export {GLIDE,flightRisePotential} from '../../../shared/src/flightPhysics';

/** Yaw steering in a radial-up frame; shared longitudinal physics exchanges speed and height. */
export class GlidePhysics{
  private readonly direction=new Vector3();
  private readonly target=new Vector3();
  private readonly axis=new Vector3();
  private readonly right=new Vector3();
  private readonly rotation=new Quaternion();
  private readonly velocity:FlightVelocity={horizontal:0,vertical:0};
  private readonly input:FlightStep={pitch:0,gravity:0,power:0,thrustPower:0,yawRate:0,brake:false,dt:0};

  /** Mutates velocity only. Rotation never grants an extra speed or rise impulse. */
  step(velocity:Vector3,up:Vector3,heading:Vector3,pitch:number,strafe:number,brake:boolean,gravity:number,power:number,dt:number,thrustPower=power,launchRecovery=0):void{
    if(!Number.isFinite(dt)||dt<=0)return;
    const steps=Math.max(1,Math.ceil(dt/(1/120))),h=dt/steps;
    Object.assign(this.input,{pitch,gravity,power,thrustPower,launchRecovery,brake,dt:h});
    for(let i=0;i<steps;i++){
      const vertical=velocity.dot(up);
      this.direction.copy(velocity).addScaledVector(up,-vertical);
      const horizontal=this.direction.length(),speed=velocity.length();
      this.right.crossVectors(heading,up).normalize();
      this.target.copy(heading).addScaledVector(this.right,strafe*.32).normalize();
      if(horizontal>1e-6)this.direction.divideScalar(horizontal);
      else this.direction.copy(this.target);
      // Keeping yaw separate from pitch prevents an about-turn from becoming
      // a vertical half-loop. Banking follows this actual curved travel path.
      this.axis.crossVectors(this.direction,this.target);
      const yaw=Math.atan2(this.axis.dot(up),MathUtils.clamp(this.direction.dot(this.target),-1,1));
      const limit=GLIDE.turnRate*(.4+.6*MathUtils.smoothstep(speed,4,16))*h;
      const turn=MathUtils.clamp(yaw*(1-Math.exp(-GLIDE.steerResponse*h)),-limit,limit);
      this.rotation.setFromAxisAngle(up,turn);this.direction.applyQuaternion(this.rotation);
      this.velocity.horizontal=horizontal;this.velocity.vertical=vertical;
      this.input.yawRate=turn/h;
      stepFlightVelocity(this.velocity,this.input);
      velocity.copy(this.direction).multiplyScalar(this.velocity.horizontal).addScaledVector(up,this.velocity.vertical);
    }
  }
}
